module.exports = __webpack_public_path__ + "img/bg-gradient.1c6bd602.png";